import styles from './index.less';
import $ from 'jquery';
import Modal from '../modal';

const defaultPrams = {
  src: '',
  iframeVideo: '',
};
export default class VideoModal extends Modal {
  constructor(props) {
    super(props);
    this.params = {
      ...defaultPrams,
      ...props,
    };
    this._initContent();
  }
  _initContent() {
    const params = this.params;
    if (params.iframeVideo) {
      this.$video = $(
        `<div class="${styles['video-wrapper']}">
          ${params.iframeVideo}
        </div>`,
      );
    } else {
      this.$video = $(
        `<div class="${styles['video-wrapper']}">
          <video webkit-crossorigin="anonymous" 
            crossorigin="anonymous"
            x5-video-player-type="h5" x5-video-player-fullscreen="false"  
            src="${params.src}" poster="${params.thumb}" 
            ${params.autoplay ? 'autoplay' : ''}
            ${params.loop ? 'loop' : ''}
            controls>
          </video>
        </div>`,
      );
    }

    this.$dom.append(this.$video);
  }
}
